import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LiderFranczyzaPage } from "@/features/strateg-cenowy/lider-franczyza/LiderFranczyzaPage";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	columnFilters: z.string().optional(),
	sortBy: z.string().optional(),
	sortDesc: z.boolean().optional(),
	missingOnly: z.boolean().optional(),
	manualOnly: z.boolean().optional(),
});
export const Route = createFileRoute("/_auth/strateg-cenowy/lider-franczyza")({
	validateSearch: searchSchema,
	beforeLoad: async ({ context }) => {
		await ensureElementVisible(context.queryClient, "sidebar.strateg-cenowy.lider-franczyza");
	},
	component: LiderFranczyzaPage,
});
